import { motion, AnimatePresence } from 'framer-motion';
import { useMemo } from 'react';

const COLORS = ['#4F86C6', '#7FA98C', '#E9B949', '#E07A5F', '#8D8880', '#6FB1D6'];

/** Lightweight confetti burst — render with a changing `fireKey` to trigger. */
export default function Confetti({ fireKey }) {
  const pieces = useMemo(
    () => Array.from({ length: 40 }).map((_, i) => ({
      id: i,
      x: (Math.random() - 0.5) * 600,
      y: 300 + Math.random() * 300,
      rot: Math.random() * 720 - 360,
      delay: Math.random() * 0.2,
      color: COLORS[i % COLORS.length],
      size: 8 + Math.random() * 8,
    })),
    [fireKey]
  );

  if (!fireKey) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[100] flex items-start justify-center overflow-hidden">
      <AnimatePresence>
        {pieces.map((p) => (
          <motion.div
            key={`${fireKey}-${p.id}`}
            initial={{ opacity: 1, x: 0, y: -20, rotate: 0 }}
            animate={{ opacity: 0, x: p.x, y: p.y, rotate: p.rot }}
            transition={{ duration: 1.6, delay: p.delay, ease: 'easeOut' }}
            style={{ width: p.size, height: p.size, backgroundColor: p.color, borderRadius: 2, marginTop: '20vh' }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
}
